// extracted by mini-css-extract-plugin
export default {"footer":"W2Rput","footer--sticky":"_0HTeUF","footerSticky":"_0HTeUF","footer--invalid":"iWqeZz","footerInvalid":"iWqeZz","footer__message":"twUUmB","footerMessage":"twUUmB"};